(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["edde/nav/includes/footer/_footer_cobranding_new.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += " <div class=\"comet-row footer-cobranding\">\n     <div class=\"footer-cobranding__inner\">\n         <div class=\"comet-row__inner\">\n             <div class=\"footer-cobranding__content\">\n                 <p class=\"footer-cobranding-hide-under-610 footer-cobranding__text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"text"), env.opts.autoescape);
output += "</p>\n                 <span class=\"comet-screenreader-only footer-cobranding__sponsor-name\">\n                     ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"name")) {
output += "\n                         ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"name"), env.opts.autoescape);
output += "\n                     ";
;
}
else {
output += "\n                         Sponsor Logo\n                     ";
;
}
output += "\n                 </span>\n                 <div class=\"footer-cobranding-logo-container\">\n                     ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"image")) {
output += "\n                         <img class=\"footer-cobranding-logo\" src=\"data:image/png;base64, ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"image"), env.opts.autoescape);
output += "\" />\n                     ";
;
}
output += "\n                 </div>\n                 <div class=\"footer-cobranding-button-container ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"url")) {
output += " hidden";
;
}
output += "\">\n                     <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"url"), env.opts.autoescape);
output += "\" class=\"comet-button comet-button--ghost comet-button--small footer-cobranding__url global-nav-ga-event\" data-gac=\"Link\" data-gaa=\"Button\" data-gal=\"Cobranding|LearnMore\" target=\"_blank\"\n                         ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page_data")),"navigation")),"cobranding")),"name")) {
output += "\n                            data-click-name=\"page_data.navigation.cobranding.name\"\n                         ";
;
}
else {
output += "\n                             data-click-name=\"Sponsor Logo\"\n                         ";
;
}
output += "\n                         data-click-type=\"Cobranding Banner\">\n                         ";
output += runtime.suppressValue((lineno = 25, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Learn More"])), env.opts.autoescape);
output += "\n                     </a>\n                 </div>\n             </div>\n         </div>\n         <div class=\"footer-cobranding__close\">\n             <button class=\"global-nav-ga-event\" data-gac=\"Link\" data-gaa=\"Button\" data-gal=\"Cobranding|Close\">\n                 <svg class=\"comet-icon--m\" focusable=\"false\">\n                      <use xlink:href=\"";
output += runtime.suppressValue((lineno = 33, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#x"])), env.opts.autoescape);
output += "\"></use>\n                 </svg>\n             </button>\n         </div>\n     </div>\n </div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("common/components/edde/templates/nav/includes/footer/_footer_cobranding_new", function(){});

